module.exports = __webpack_public_path__ + "static/media/dansketext-semibold.b92d03b1.woff";